import React, { useState } from 'react';

const PricingSection = () => {
  const [selectedProduct, setSelectedProduct] = useState('multiple');

  const handleSelect = (product) => {
    setSelectedProduct(product);
  };

  return (
    <section id="pricing" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Choose your product</h2>
          <div className="w-24 h-1 bg-indigo-600 mx-auto mb-6"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Pick a product below to view pricing and details.
          </p>
        </div>

        {/* Product Options */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          <button
            onClick={() => handleSelect('multiple')}
            className={`rounded-xl p-6 border-2 transition-transform duration-300 hover:scale-105 ${selectedProduct === 'multiple' ? 'border-indigo-600' : 'border-gray-200'}`}
          >
            <h3 className="text-xl font-semibold text-gray-900 mb-2">Multiple Screenshots</h3>
            <p className="text-gray-600">Best for advanced screenshot workflows</p>
          </button>

          <button
            onClick={() => handleSelect('xpath')}
            className={`rounded-xl p-6 border-2 transition-transform duration-300 hover:scale-105 ${selectedProduct === 'xpath' ? 'border-indigo-600' : 'border-gray-200'}`}
          >
            <h3 className="text-xl font-semibold text-gray-900 mb-2">XPath Helper 2.0</h3>
            <p className="text-gray-600">Free developer utility</p>
          </button>

          <button
            onClick={() => handleSelect('sitemap')}
            className={`rounded-xl p-6 border-2 transition-transform duration-300 hover:scale-105 ${selectedProduct === 'sitemap' ? 'border-indigo-600' : 'border-gray-200'}`}
          >
            <h3 className="text-xl font-semibold text-gray-900 mb-2">Sitemap Checker</h3>
            <p className="text-gray-600">Free & open source</p>
          </button>
        </div>

        {/* Pricing Display */}
        <div className="text-center">
          {selectedProduct === 'multiple' && (
            <div className="grid md:grid-cols-1 gap-8 mt-8 max-w-2xl mx-auto">
              {/* Plan Card with Free Info */}
              <div className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow duration-300">
                <h4 className="text-2xl font-bold text-gray-900 mb-2">Multiple Screenshots</h4>
                {/* Free version at the top */}
                <div className="mb-8 border-b border-gray-200 pb-6">
                  <h5 className="text-lg font-semibold text-gray-900 mb-2">Free version</h5>
                  <ul className="text-sm text-gray-700 space-y-2 text-left">
                    <li>✔ Unlimited bulk screenshots in PNG</li>
                    <li>✔ Premium features enabled for 15 URLs every 6 hours (1 try = 1 URL)</li>
                    <li>✔ Automatic reset every 6 hours</li>
                    <li>⚠ After the 15-URL limit, only basic bulk PNG is available until the reset</li>
                  </ul>
                </div>

                {/* Premium section */}
                <p className="text-gray-600 mb-2">Premium version — Unlimited everything</p>
                <div className="flex items-baseline justify-center mb-6">
                  <span className="text-4xl font-extrabold text-gray-900 mr-2">$9.99</span>
                  <span className="text-gray-600">/ month</span>
                </div>
                <ul className="text-sm text-gray-700 space-y-2 mb-6 text-left">
                  <li>✔ Customizable delay for screenshots</li>
                  <li>✔ Flexible file names</li>
                  <li>✔ Various screenshot formats (PNG, JPG, PDF, WebP)</li>
                  <li>✔ CSV generation for URL and file name mapping</li>
                  <li>✔ Optional path column in CSV for easier file organization</li>
                  <li>✔ Add URL and timestamp overlay to screenshots</li>
                  <li>✔ Fullscreen Mode - capture screenshots in full browser fullscreen (F11) for clean visuals</li>
                  <li>✔ Fullpage Mode - automatically scrolls to capture the entire page without duplicated sections</li>
                  <li>✔ XPath cropping - clip screenshots to a specific element by providing its XPath</li>
                  <li>✔ XPath picker tool - visually select any element on the page and save its XPath for reuse</li>
                  <li>✔ Highlight by XPath - automatically scroll to an element and frame it in the screenshot without cropping</li>
                  <li>✔ Window Mode - run the extension in a separate dedicated window for better stability</li>
                  <li>✔ Auto Capture - schedule periodic screenshots of selected links to monitor changes over time, works with all features (e.g. XPath, API upload)</li>
                  <li>✔ API Upload - send screenshots directly to your own API endpoint (JSON base64 or multipart/form-data) instead of saving locally</li>
                </ul>
                <a
                  href="https://extensionpay.com/extension/multiple-screenshots/choose-plan?api_key=36cb7866-8b0c-4ffd-a0d4-f49487c25d62"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block text-center bg-[rgb(0,131,234)] hover:bg-[rgb(0,100,180)] text-white font-semibold py-3 px-4 rounded-lg"
                >
                  Subscribe – $9.99 / month
                </a>
                <p className="text-xs text-gray-400 mt-3 text-center">Billing and subscription management via ExtensionPay</p>
              </div>
            </div>
          )}


          {selectedProduct === 'xpath' && (
            <div className="bg-gray-100 rounded-xl p-8 text-center max-w-xl mx-auto">
              <h3 className="text-2xl font-semibold text-gray-900 mb-4">Free to use</h3>
              <p className="text-gray-600">XPath Helper 2.0 is completely free and open source.</p>
            </div>
          )}

          {selectedProduct === 'sitemap' && (
            <div className="bg-gray-100 rounded-xl p-8 text-center max-w-xl mx-auto">
              <h3 className="text-2xl font-semibold text-gray-900 mb-4">Free to use</h3>
              <p className="text-gray-600">Sitemap Checker is free and always will be.</p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
